import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../components/PageShell";
import ProductCard from "../components/ProductCard";
import { hoodies } from "../mock";
import { ArrowRight } from "lucide-react";

export default function HoodiesSweatshirts() {
  return (
    <PageShell kicker="Hoodies & Sweatshirts" title="For the colder half of the year" subtitle="Heavier fleece, bigger print area, and the piece people actually keep. Choose your weight, then print your design or ours.">
      <section className="max-w-4xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 sm:grid-cols-2 gap-8">
        {hoodies.map((h) => <ProductCard key={h.id} product={h} />)}
      </section>
      <section className="bg-[color:var(--dms-navy)] py-20">
        <div className="max-w-3xl mx-auto text-center px-5">
          <h2 className="font-serif text-3xl md:text-4xl text-white">Want your design on the hoodie?</h2>
          <p className="mt-4 text-white/75">Upload your artwork or tell us the idea — we'll send back a proof before we print.</p>
          <div className="mt-8"><Link to="/custom-design" className="btn-peach">Customize a hoodie <ArrowRight className="w-4 h-4" /></Link></div>
        </div>
      </section>
    </PageShell>
  );
}
